module.exports = __webpack_public_path__ + "img/Basement_s0_b0_9x12_1_CCC_UK.4f11ceed.png";